<template>
  <div class="app2">
    <div class="content">
      <div class="content-nav" v-for="(item, index) in list" :key="index">
        <div class="content-nav-card" @click="goDetail(item)">
          <div>
            <img :src="item.fmtp" alt="" />
          </div>
          <div class="content_s">
            <div class="bts">
              <p>{{ item.bt }}</p>
              <div>
                <img v-if="item.fl == '01'" src="@images/icon2/swzl-card.png" />
                <img v-if="item.fl == '02'" src="@images/icon2/fwzl-card.png" />
                <img v-if="item.fl == '03'" src="@images/icon2/zpxx-card.png" />
                <img v-if="item.fl == '04'" src="@images/icon2/jypx-card.png" />
                <img v-if="item.fl == '99'" src="@images/icon2/other-card.png" />
                <p v-if="showQx && item.status == '03'" @click.stop="clickQx(item)">取消</p>
              </div>
            </div>
          </div>
          <div  v-if="item.status=='03'||item.status=='04'" class="other-time">
            <p>发布时间：{{ item.fbsj || '--' }}</p>
            <p>到期日期：{{ item.gqsj || '--' }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import { Dialog } from 'vant'
export default {
  props: {
    list: {
      type: Array,
      default() {
        return []
      },
    },
    showQx: {
      //等于1显示
      type: Boolean,
      default: false,
    },
    // 自定义返回逻辑
    clickItem: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      listData: [],
      show: false,
      obj: {},
    }
  },
  watch: {
    list: {
      immediate: true,
      handler() {
        this.listData = this.list
      },
    },
  },
  created() {},
  methods: {
    goDetail: function (e) {
      this.$store.state.wallView = e
      this.$router.push({
        path: '/hmhq/wallDetail',
      })
    },
    clickQx(item) {
      Dialog.confirm({
        title: '提示',
        message: '您确定要取消发布',
      })
        .then(() => {
          let params = {
            id: item.id,
          }
          getAction('/zhshj/hmfwggq/qxfb', params).then((res) => {
            this.$router.go(0)
          })
        })
        .catch(() => {
        })
    },
  },
}
</script>

<style lang="less">
.app2 {
  width: 100%;
  height: 100%;
  background-color: #f6f7f9;
}
p {
  margin: 0px;
  padding: 0px;
}
input {
  border: none;
}
.content {
  padding: 0px 10px 50px;
  font-size: 16px;
  box-sizing: border-box;
  &-nav {
    width: 100%;
    border-radius: 10px;
    margin-bottom: 16px;
    background: white;
    overflow: hidden;
    &-card {
      background: white;
      padding: 10px 12px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      box-sizing: border-box;
      > div:first-child {
        width: 24%;
        height: 80px;
        img {
          width: 100%;
          height: 100%;
          max-width: 94%;
        }
      }
      .content_s {
        width: 74%;
        position: relative;
        .bts {
          width: 100%;
          height: 100%;
          display: flex;
          flex-wrap: wrap;
          flex-direction: column;
          justify-content: space-between;
          > p {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2; //行数
            -webkit-box-orient: vertical;
          }
          div {
            display: flex;
            justify-content: space-between;
            p {
              color: #969696;
              font-size: 12px;
              padding: 2px 8px;
              background: #f5f6f8;
              border-radius: 6px;
              border: 1px solid #b5b5b580;
            }
          }
          img {
            width: 60px;
            height: 20px;
          }
        }
        .clearfb {
          position: absolute;
          right: 0px;
          top: 50%;
          background: #f5f6f8;
          border-radius: 6px;
          border: 1px solid #b5b5b580;
          transform: translateY(-50%);
          p {
            color: #969696;
            font-size: 14px;
            padding: 3px 8px;
          }
        }
      }
      .other-time {
        width: 100%;
        border-top: 1px solid #f5f6f8;
        padding: 8px 0px 0px;
        margin: 10px 0px 0px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        p {
          font-size: 10px;
          color: #b5b5b5;
        }
      }
    }
  }
}
</style>
